import React from 'react';
import { coachImages, aboutMe } from '../../data/mock';

const AboutMe = () => {
  return (
    <section id="about" className="py-16 sm:py-24 bg-black" data-testid="about-section">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* Text Side */}
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 uppercase tracking-wider" data-testid="about-title">
              {aboutMe.title}
            </h2>
            <div className="space-y-4">
              {aboutMe.paragraphs.map((p, i) => (
                <p key={i} className="text-white/60 text-sm sm:text-base leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
          </div>

          {/* Before / After Images Side */}
          <div className="order-1 lg:order-2">
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              <div className="group">
                <div className="overflow-hidden border border-white/15">
                  <img
                    src={coachImages.before}
                    alt="Daniel before transformation"
                    className="w-full aspect-[3/4] object-cover transition-transform duration-500 group-hover:scale-105"
                    data-testid="about-before-image"
                  />
                </div>
                <p className="text-center text-white/50 text-xs mt-3 font-bold uppercase tracking-[0.2em]">Before</p>
              </div>
              <div className="group">
                <div className="overflow-hidden border border-white/40">
                  <img
                    src={coachImages.after}
                    alt="Daniel after transformation"
                    className="w-full aspect-[3/4] object-cover transition-transform duration-500 group-hover:scale-105"
                    data-testid="about-after-image"
                  />
                </div>
                <p className="text-center text-white/70 text-xs mt-3 font-bold uppercase tracking-[0.2em]">After</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
